import { render } from "./FormTextarea.vue?vue&type=template&id=6956ce7e&scoped=true"
import script from "./FormTextarea.vue?vue&type=script&lang=js"
export * from "./FormTextarea.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-6956ce7e"

export default script